import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/Button';
import { ButtonBack } from '../../components/ButtonBack';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { Award } from './components/Award';

import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { useCart } from '../../hooks/useCart';
import { formatMoney } from '../../utils/formatMoney';
import { numberWithCommas } from '../../utils/numberWithCommas';
import { usePoints } from '../../hooks/usePoints';
import { ServiceUnavailableModal } from './components/ServiceUnavailable';

export function Cart() {
  const navigate = useNavigate();
  const {
    cart,
    totalPaymentValue,
    totalPremiumPrice,
    isAwardMoney,
    isAwardVariable,
  } = useCart();
  const { player, client } = useAuth();
  const { setRemainingPoints, availableToRedeem } = usePoints();
  const [serviceUnavailableModalIsOpen, setServiceUnavailableModalIsOpen] =
    useState(false);
  const balance =
    Number(player.totalPoints) -
    Number(player.redeemedPoints ? player.redeemedPoints : 0);

  useEffect(() => {
    const sessionRemainingPoints = sessionStorage.getItem('remainingPoints');

    if (sessionRemainingPoints) {
      const sessionRemainingPointsNumber = JSON.parse(sessionRemainingPoints);
      sessionRemainingPointsNumber >= 0 &&
        setRemainingPoints(sessionRemainingPointsNumber);
    }
  }, []);

  const renderEmptyCart = () => {
    return (
      <>
        <div className="text-center my-3">
          <p className="m-0 fs-3 fw-semibold">Ops!...</p>
          <p className="m-0">O carrinho está vazio!</p>
        </div>
      </>
    );
  };

  const onHandleConfirmRescue = () => {
    // if (cart && cart.some((award) => award.premiumType.value !== 'Digital')) {
    //   setServiceUnavailableModalIsOpen(true);
    // } else {
    navigate(routes.CONFIRM_RESCUE);
    // }
  };

  return (
    <>
      <HelmetComponent
        clientLogoURL={client?.logoURL}
        companyName={client?.companyName}
        clientFavicon={client?.favIcon}
        primaryColor={client?.primaryColor}
        secondaryColor={client?.secondaryColor}
        tabTitle={'Carrinho'}
      />
      <div className="container">
        <div className="row">
          <div className="my-3">
            <ButtonBack title="Meu carrinho" />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Card>
              <>
                {(!cart || cart.length === 0) && renderEmptyCart()}

                {cart &&
                  cart.length > 0 &&
                  cart.map((award) => (
                    <Award key={award.premiumId} award={award} />
                  ))}

                {cart && cart.length > 0 && (
                  <>
                    {isAwardMoney && isAwardVariable && (
                      <>
                        <p className="fs-4 fw-semibold m-0 text-right">
                          Total:
                          <span className="ms-3 fs-4 fw-normal">
                            {availableToRedeem
                              ? formatMoney(availableToRedeem)
                              : formatMoney(balance)}
                          </span>
                        </p>
                      </>
                    )}

                    {isAwardMoney && !isAwardVariable && (
                      <>
                        <p className="fs-4 fw-semibold m-0 text-right">
                          Total:
                          <span className="ms-3 fs-4 fw-normal">
                            {formatMoney(totalPaymentValue)}
                          </span>
                        </p>
                      </>
                    )}

                    {!isAwardMoney && !isAwardVariable && (
                      <>
                        <p className="fs-4 fw-semibold m-0 text-right">
                          Total:
                          <span className="ms-3 fs-4 fw-normal">
                            {numberWithCommas(totalPremiumPrice)}{' '}
                            {client?.coinName
                              ? client.coinName.replace(
                                  /\((\w+)\)/,
                                  (_, conteudo) => conteudo
                                )
                              : 'pontos'}
                          </span>
                        </p>
                      </>
                    )}

                    <div className=" mt-3 d-flex justify-content-end">
                      <Button
                        onClick={onHandleConfirmRescue}
                        disabled={!cart || cart.length === 0}
                        text="Continuar"
                        color="primary"
                      />
                    </div>
                  </>
                )}
              </>
            </Card>
          </div>
        </div>
        <ServiceUnavailableModal
          modalIsOpen={serviceUnavailableModalIsOpen}
          toggleModal={() => setServiceUnavailableModalIsOpen(false)}
        />
      </div>
    </>
  );
}
